import { runClientComponent } from '../../_common/client/client-component-runner';
import { OnpageSearchComponent } from './onpage-search.component';

runClientComponent({ OnpageSearchComponent });
